import { z } from 'zod';
// ---- Discovery state ----------------------------------------------------------------
export const DiscoveryStateSchema = z.enum(['unknown', 'known', 'located']);
// ---- Place location -----------------------------------------------------------------
export const PlaceLocationOffSceneSchema = z.object({
    type: z.literal('off-scene'),
});
export const PlaceLocationHexSchema = z.object({
    type: z.literal('hex'),
    gameId: z.string(),
    x: z.number().int(),
    y: z.number().int(),
});
export const PlaceLocationRegionSchema = z.object({
    type: z.literal('region'),
    gameId: z.string(),
    hexes: z.array(z.object({ x: z.number().int(), y: z.number().int() })),
});
export const PlaceLocationSchema = z.discriminatedUnion('type', [
    PlaceLocationOffSceneSchema,
    PlaceLocationHexSchema,
    PlaceLocationRegionSchema,
]);
// ---- DTOs ---------------------------------------------------------------------------
export const PlaceDTOSchema = z.object({
    id: z.string(),
    characterId: z.string(),
    name: z.string(),
    description: z.string().optional(),
    source: z.string().optional(),
    location: PlaceLocationSchema,
    discoveryState: DiscoveryStateSchema.optional(),
    createdAt: z.string(),
});
